import { render, staticRenderFns } from "./exportFenxiRankbigData.vue?vue&type=template&id=f4647bc4&scoped=true"
import script from "./exportFenxiRankbigData.vue?vue&type=script&lang=js"
export * from "./exportFenxiRankbigData.vue?vue&type=script&lang=js"
import style0 from "./exportFenxiRankbigData.vue?vue&type=style&index=0&id=f4647bc4&prod&scoped=true&lang=css"
import style1 from "./exportFenxiRankbigData.vue?vue&type=style&index=1&id=f4647bc4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4647bc4",
  null
  
)

export default component.exports